import { render } from "react-dom";
import React from "react";
import UIMain from "assets/js/UIMain";
import UiWrapper from "./assets/js/UiWrapper";
import * as Sentry from "@sentry/react";
import "cakemail-ui-components/lib/dist/sass/cakebootstrap_main.scss";
import "./assets/js/reactBoot.scss";
import BrandWrapper from "assets/js/BrandWrapper";
import partnerStackAndRedirect from "utils/partnerStack";
import { getUrlQueryParam, saveUtms } from "utils/urlUtils";
import { GATEWAY_PROXY } from "utils/apiUtils";
import posthog from "posthog-js";

if(!window.location.href.includes("public")){
	const fonts =  require("./assets/js/fonts.scss");
}

const amplitude = require("amplitude-js");
amplitude.getInstance().init("7087b825b8aca41083da869a2cce4edf");
try {
	window.version = VERSION;
} catch (error) {
	console.warn(
		"an error occurred on fetching the version, error details : ",
		error
	);
}

if (top !== self) top.location.replace(self.location.href);

try {
	Typekit.load({ async: true });
} catch (e) {}

if (process.env.ENV !== "dev") {
	Sentry.init({ dsn: process.env.SENTRY_DSN, environment: process.env.ENV });
}

// ----- INJECT PLAUSIBLE MANUAL SCRIPT -----
const hostname = window.location.hostname;
let finalHost =
	hostname.indexOf("www.") === 0 ? hostname.replace("www.", "") : hostname;

const script = document.createElement("script");
script.type = "text/javascript";
script.setAttribute(
	"data-domain",
	finalHost + ",rollup.cakemail-ngapp.com,rollup.cakemail-product.com"
);
script.src = "https://plausible.io/js/script.hash.js";

document.head.appendChild(script);


saveUtms();

// ----- INSERT USER BRAND CSS -----
const userBrandOwner = getUrlQueryParam("a");
if(userBrandOwner){
	document.querySelector(
		"head"
	).innerHTML += `<link rel="stylesheet" href="${GATEWAY_PROXY}/brands/${userBrandOwner}/brand.css" type="text/css"/>`;
}

if (partnerStackAndRedirect()) {
	render(
		"",
		document.getElementById("root")
	);
} else {
	render(
		<BrandWrapper>
			<UiWrapper>
				<UIMain/>
			</UiWrapper>
		</BrandWrapper>,
		document.getElementById("root")
	);
}


